// Unpublished Work © 2021-2023 Deere & Company.

import {CSCMessageTypes} from '../literals/csc-message-types';

const getParentURL = () => {
    if (globalThis.location === globalThis.parent.location) {
        return globalThis.location.href;
    }

    return globalThis.document.referrer || '*';
};

export const postCSCMessage = (type, payload = {}) => globalThis.parent.postMessage(JSON.stringify({
    type,
    ...payload
}), getParentURL());

export const postCustomerMessage = (type, customer) => postCSCMessage(type, {
    customer
});

export const postLoadedMessage = () => postCSCMessage(CSCMessageTypes.LOADED);
